/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { Enabled } from './Enabled';
import { FileTreeDirectoryItem } from './FileTreeDirectoryItem';
import { FileTreeFileItem } from './FileTreeFileItem';
const EnabledSolutionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'fileTree',
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['file', FileTreeFileItem],
            ['dir', FileTreeDirectoryItem],
        ]),
        'file_tree',
    ],
]), Enabled);
export class EnabledSolution extends Enabled {
    static decode(input) {
        return EnabledSolutionParser.decode(input).map(res => new EnabledSolution(res));
    }
    static unsafeDecode(input) {
        return EnabledSolution.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return EnabledSolutionParser.encode(data);
    }
    static schema() {
        return EnabledSolutionParser.schema();
    }
}
